import React, { useState } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { CharactersApiService } from 'services';
import { ICharacterDto } from 'shared/interfaces'; // ✅ используем тип персонажа

import './CharactersTable.scss';

interface CharactersTableProps {
    characters: ICharacterDto[];
    setCharacters: (chars: ICharacterDto[]) => void;
    onDelete: (character: ICharacterDto) => void;
}

const CharactersTable: React.FC<CharactersTableProps> = ({ characters, setCharacters, onDelete }) => {
    const [notice, setNotice] = useState<string | null>(null);

    const handleSubmit = async () => {
        const files: any[] = [];
        characters.forEach((char) => {
            if (char.level) {
                files.push([char.id, char.level]); // передаём id персонажа и выбранный уровень
            }
        });

        try {
            const data = await CharactersApiService.postTask(files); // должен быть метод в API
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (data) {
                setNotice('Персонажи успешно распределены');
                setCharacters([]);
                const timer = setTimeout(() => setNotice(null), 5000);
                return () => clearTimeout(timer);
            }
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <form>
            <TableContainer sx={{ fontWeight: 'bold' }} className="table-title">
                Распределение персонажей
            </TableContainer>
            <Table className="table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }} align="center">Имя персонажа</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align="center">Раса</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align="center">Класс</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align="center">Уровень</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align="center">Удалить</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {characters.map((char, index) => (
                        <TableRow key={index}>
                            <TableCell align="center">{char.name}</TableCell>
                            <TableCell align="center">{char.race}</TableCell>
                            <TableCell align="center">{char.charClass}</TableCell>
                            <TableCell align="center">{char.level ?? '-'}</TableCell>
                            <TableCell align="center">
                                <button
                                    type="button"
                                    className="delete"
                                    onClick={() => onDelete(char)}
                                >
                                    Удалить
                                </button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {notice && <div style={{ color: 'green', textAlign: 'center' }}>{notice}</div>}
            <Button
                variant="contained"
                sx={{ display: 'flex', margin: 'auto' }}
                disabled={characters.length === 0}
                onClick={handleSubmit}
            >
                Отправить
            </Button>
        </form>
    );
};

export default CharactersTable;
